import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { CustomerPortal } from './CustomerPortal';
import { useRbac } from '../../context/RbacContext';

const CustomerRoutes: React.FC = () => {
  const { hasPermission } = useRbac();

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Routes>
        {/* Customer Dashboard */}
        <Route 
          path="/" 
          element={<CustomerPortal />}
        />
        
        {/* Customer Dashboard (alternative route) */}
        <Route 
          path="dashboard" 
          element={<CustomerPortal />}
        />
        
        {/* Customer Portal (for detailed order management) */}
        <Route 
          path="portal" 
          element={<CustomerPortal />}
        />
        
        {/* Profile Management */}
        <Route 
          path="profile" 
          element={<CustomerPortal />}
        />
        
        {/* Notifications */}
        <Route 
          path="notifications" 
          element={<CustomerPortal />}
        />
        
        {/* Fallback route */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Box>
  );
};

export default CustomerRoutes; 